import React from "react";
import "./CapabilityBlock.css";

function CapabilityBlock({ badge, title, description, highlight, capabilities }) {
  return (
    <section className="block block11">

      <div className="block11-content">

        <div className="block11-left">
          <span className="block11-badge">{badge || ''}</span>
          <h2 className="block11-title">{title || ''}</h2>
          <p className="block11-description">{description || ''}</p>
          <div className="block11-highlight">{highlight || ''}</div>
        </div>

        <div className="block11-right">
          {(capabilities || []).map((capability, index) => (
            <div key={index} className="capability-card">
              <div className="card-dot"></div>
              {capability}
            </div>
          ))}
        </div>

      </div>

    </section>
  );
}

export default CapabilityBlock;
